import React from 'react';

function Vietnam(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_123960)">
        <mask
          id="mask0_800_123960"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_123960)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0H36V24H0V0Z"
            fill="#F7FCFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#E31D1C"
          />
          <mask
            id="mask1_800_123960"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_123960)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18.0696 15.98L12.2749 19.2549L14.2186 13.5219L10.0854 9.77622L15.7837 9.66557L18.3048 4.00574L20.6021 9.74033L26.2868 9.82853L22.0149 13.6429L24.0097 19.0968L18.0696 15.98Z"
              fill="#FFD221"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_123960">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Vietnam;
